import {contactApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const createList = async (contactList) => {
  try {
    const result = await fetch(`${contactApiHostName}/contacts`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(contactList),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
